import React, { useState } from "react";
import ChooseStudyGroupPopup from "./chooseStudyGroupPopup/ChooseStudyGroupPopup";
import ClassroomWizardPopup from "./Classroom/classroomWizardPopup/ClassroomWizardPopup";
import MoodleWizardPopup from "./moodleWizardPopup/MoodleWizardPopup";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import { logError } from "../../../../shared/errors/logError";
import classes from "./CreateStudyGroupFlowWizard.module.css"

const CreateStudyGroupFlowWizard = ({ onClose, studyGroupId }) => {

    const [studyGroup, setStudyGroup] = useState(null);

    const handleFinishAll = () => {
        setStudyGroup(null);
        onClose && onClose();
    };

    const handleSelectGroup = (group) => {
        setStudyGroup(group);
        logError({ type: "create-study-group", error: "create_study_group_platform_selected", desc: "create_study_group_platform_selected", component: "CreateStudyGroupFlowWizard", props: { studyGroupId } });
    };

    const generateCreateStudyGroupType = () => {

        if (studyGroup.flow === "link") {
            setTimeout(() => { handleFinishAll(); }, 1);
            return <NavigateLink link={studyGroup?.link} auto={true} />
        }

        switch (studyGroup?.key) {
            case "google":
            case "microsoft":
                return <ClassroomWizardPopup studyGroup={studyGroup} studyGroupId={studyGroupId} onClose={handleFinishAll} />
            case "moodle-highschool":
                return <MoodleWizardPopup moodle={studyGroup} onClose={handleFinishAll} />
            case "moodle-elementary":
                return <MoodleWizardPopup moodle={studyGroup} onClose={handleFinishAll} />
        }
    }

    return (
        <>
            {!studyGroup ?
                <ChooseStudyGroupPopup onClose={handleFinishAll} onSelectGroup={handleSelectGroup} />
                :
                generateCreateStudyGroupType()
            }
        </>
    );
};

export default CreateStudyGroupFlowWizard;
